import React from 'react';
import PropTypes from 'prop-types';

export default function SessionExpiredModal({ open, onClose }) {
  return (
    <>
      <div className={`overlay-black modal ${open && 'modal-open'}`}>
        <div className="border-dark-gray content pad-30">
          <p>
            Your session has expired.  Please login again.
          </p>
          
          <div className="text-center">
            <button className="text-center" type="button" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

SessionExpiredModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
